import { render, staticRenderFns } from "./ReportFeature.vue?vue&type=template&id=99cc2f0c&scoped=true&"
import script from "./ReportFeature.vue?vue&type=script&lang=js&"
export * from "./ReportFeature.vue?vue&type=script&lang=js&"
import style0 from "./ReportFeature.vue?vue&type=style&index=0&id=99cc2f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cc2f0c",
  null
  
)

export default component.exports